<div class="alert supo-aim-colour alert-dismissible fade show" role="alert" *ngIf="messageActive()">
    <fa-icon icon="info-circle" size="lg" class="col-1 ms-5"></fa-icon>
    <strong>Warning</strong>
    <span *ngIf="'frontpage' === pageType" class="col align-self-center">{{aimMessageFrontPage.message}}</span>
    <span *ngIf="'lastpage' === pageType" class="col align-self-center">{{aimMessageLastPage.message}}</span>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="setDisplayInfoBox()">
        <fa-icon icon="times" class="col-1 ms-5"></fa-icon>
    </button>
</div>
